import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_EXPENSES } from './vehicleEntityConfigs';

const VehicleExpenses = () => <VehicleEntityGridPage config={VEHICLE_EXPENSES} />;

export default VehicleExpenses;
